const __DEV__ = false;

import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import { getStyles, sanitizeProps } from '../../styles/theme/index.js';
import { S } from './styles.js';
import { jsx } from '@emotion/react';
import mergeDefaultProps from '../../utils/merge-default-props.js';

var _excluded = ["children", "dataTestId"];
var defaultProps = {
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  isInline: false,
  spacingProperty: 'padding',
  spacingSize: 'm',
  scale: 's',
  noImportant: false
};
var InlineInternal = function InlineInternal(props, ref) {
  var propsInternal = mergeDefaultProps(props, defaultProps);
  var children = propsInternal.children,
      dataTestId = propsInternal.dataTestId,
      rest = _objectWithoutProperties(propsInternal, _excluded);
  return jsx("span", _extends({
    ref: ref,
    css: function css(theme) {
      return [S.container(theme, propsInternal), getStyles('container', theme, propsInternal)];
    },
    "data-testid": dataTestId
  }, sanitizeProps(rest)), children);
};
InlineInternal.displayName = 'InlineInternal';
var Inline = Object.assign( React__default.forwardRef(InlineInternal), {
  displayName: 'Inline'
});

export { Inline };
//# sourceMappingURL=inline.js.map
